import React from 'react';
import classNames from 'classnames';
import styles from './divider.module.scss';

type Props = {
  className?: string;
};

export const Divider: React.FC<Props> = ({ className }) => {
  return <hr className={classNames(styles.root, className)} />;
};
